import React from 'react';
import axios from 'axios';
import ContractBuilder from '../contractBuilder';
import ContractManagement from './contractManagement/';

class ContractDetail extends React.Component {
  state = {
    editable: false,
    loading: true,
  };

  componentDidMount = () => {
    const { id } = this.props;

    axios.get(`/contracts/${id}/`)
      .then(res => {
        const { data } = res;

        if (data.status === '1' || data.status === '2' || data.status === '3' || data.status === '6') {
          this.setState({
            editable: false,
            loading: false,
          });
        } else {
          this.setState({
            editable: true,
            loading: false,
          });
        }
      })
  }

  render() {
    const { editable, loading } = this.state;

    if (this.state.loading) {
      return <div></div>
    }

    return editable
      ? <ContractBuilder id={this.props.id} />
      : <ContractManagement id={this.props.id} />
  }
}

export default ContractDetail;
